import React, { useState, useRef, useEffect } from 'react';
import { BookmarkBorder, Bookmark, ChatBubbleOutline, IosShare } from '@mui/icons-material';
import { shareOrCopyUrl } from '../../utils/share';
import { trackShareClick } from '../../lib/gaEvents';
import { CONTENT_TYPE, PAGE_TYPE } from '../../constants/gaEnums';
import { useUserStore } from '../../stores/userStore';
import { useWebLocale } from '../../contexts/WebLocaleContext';
export default function PlaylistDetailActions(props) {
  const user = useUserStore((s) => s.user);
  return (
    <PlaylistDetailActionsSession
      key={`${user?.id ?? 'guest'}:${props.playlist.id}`}
      {...props}
      user={user}
    />
  );
}
function PlaylistDetailActionsSession({ playlist, saved, pending, onSave, onComments, user }) {
  const { locale } = useWebLocale(),
    en = locale === 'en';
  const [status, setStatus] = useState('');
  const pendingShare = useRef(false),
    alive = useRef(true);
  useEffect(() => {
    alive.current = true;
    return () => {
      alive.current = false;
    };
  }, []);
  const active = () =>
    alive.current && String(useUserStore.getState().user?.id) === String(user?.id);
  const [sharing, setSharing] = useState(false);
  const share = async () => {
    if (pendingShare.current) return;
    pendingShare.current = true;
    setSharing(true);
    setStatus('');
    const title = `${playlist.title}${playlist.username ? ` — ${playlist.username}` : ''}`;
    try {
      const result = await shareOrCopyUrl({
        url: `https://postpop.kr/lists/${playlist.id}`,
        event: { playlistId: playlist.id, surface: 'PLAYLIST_DETAIL', section: 'SHARE' },
        title,
        text: title,
      });
      if (!active()) return;
      if (result === 'copied') setStatus(en ? 'Link copied.' : '공유 문구와 링크를 복사했어요.');
      if (result !== 'cancelled')
        trackShareClick(
          {
            contentType: CONTENT_TYPE.LIST,
            contentId: playlist.id,
            contentName: playlist.title,
            pageType: PAGE_TYPE.LIST_POST,
          },
          user,
        );
    } catch {
      if (active())
        setStatus(en ? 'Could not share. Try again.' : '공유하지 못했어요. 다시 시도해 주세요.');
    } finally {
      pendingShare.current = false;
      if (active()) setSharing(false);
    }
  };
  return (
    <>
      <div className="pp-playlist-action-row">
        <button
          type="button"
          className={saved ? 'is-active' : ''}
          aria-pressed={saved}
          disabled={pending}
          onClick={onSave}
        >
          {saved ? <Bookmark /> : <BookmarkBorder />}
          <span>{en ? (saved ? 'Saved' : 'Save') : saved ? '저장됨' : '저장'}</span>
        </button>
        <button type="button" onClick={onComments}>
          <ChatBubbleOutline />
          <span>{en ? 'Comments' : '댓글'}</span>
        </button>
        <button type="button" disabled={sharing} onClick={share}>
          <IosShare />
          <span>{en ? 'Share' : '공유'}</span>
        </button>
      </div>
      {status && (
        <p role="status" className="pp-playlist-action-status">
          {status}
        </p>
      )}
    </>
  );
}
